"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TournamentDetail = /** @class */ (function () {
    function TournamentDetail() {
    }
    return TournamentDetail;
}());
exports.default = TournamentDetail;
